import React, { useRef, useState, useEffect } from "react";
import approveSeal from "../images/approve.jpg";
import { message, Button, Select, DatePicker } from 'antd';
import axios from "../../services/axios";
import { useLocation, useNavigate } from 'react-router-dom';
import moment from "moment";
import { Page, Text, View, Document, StyleSheet, pdf, Image } from '@react-pdf/renderer';
import { DOCUMENT_CONTROLLER, CONSULTANT_DOCUMENT_CONTROLLER, SUBCONTRACTOR_DOCUMENT_CONTROLLER } from "../../constants/role";
const { Option } = Select;

const Transmittal = () => {
  const formRef = useRef(null);
  const wrapperRef = useRef(null); 
  const navigate = useNavigate();
  const location = useLocation();
  const [isApproved, setIsApproved] = useState(false);
  const [errors, setErrors] = useState({});
  const [assignedProjects, setAssignedProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [clientName, setClientName] = useState("");
  const [engineer, setEngineer] = useState("");
  const [contractor, setContractor] = useState("");
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [filters, setFilters] = useState([]);
  const role = localStorage.getItem('role');
  const today = new Date().toISOString().split("T")[0];
  const isConsultantDC = role.includes(CONSULTANT_DOCUMENT_CONTROLLER);
  const SUBMITTED_FOR_OPTIONS = isConsultantDC
    ? [
        "Approved",
        "Approved with Comments",
        "Revise & Resubmit",
        "Rejected",
        "Responded",
        "For Approval",
        "For Your Information",
        "Response Required",
      ]
    : [
        "For Approval",
        "For Your Information",
        "Response Required",
      ];

  const user = localStorage.getItem("user");
  const projectName = JSON.parse(localStorage.getItem('Project'));
  const userType = localStorage.getItem('userType');
  const [documentRows, setDocumentRows] = useState([]);
  const [transmittalFile, setTransmittalFile] = useState(null);

  // const hideEngineerRemarks =
  //   role.includes(DOCUMENT_CONTROLLER) && userType === "Contractor";

  // const hideClientRemarks =
  //   (role.includes(DOCUMENT_CONTROLLER) && userType === "Contractor") ||
  //   (role.includes(CONSULTANT_DOCUMENT_CONTROLLER) && userType === "Consultant");

  // const hideContractorRemarks =
  //   role.includes(CONSULTANT_DOCUMENT_CONTROLLER) && userType === "Consultant";

  // const hideSubContractorREmarks =
  //   role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER) && userType === "Subcontractor";

  // Hide rules for remarks


  const isSubcontractorDC =
    role.includes(SUBCONTRACTOR_DOCUMENT_CONTROLLER) && userType === "Subcontractor";

  const hideEngineerRemarks =
    isSubcontractorDC ||
    (role.includes(DOCUMENT_CONTROLLER) && userType === "Contractor");

  const hideClientRemarks =
    isSubcontractorDC ||
    (role.includes(DOCUMENT_CONTROLLER) && userType === "Contractor") ||
    (role.includes(CONSULTANT_DOCUMENT_CONTROLLER) && userType === "Consultant");

  const hideContractorRemarks =
    isSubcontractorDC ||
    (role.includes(CONSULTANT_DOCUMENT_CONTROLLER) && userType === "Consultant");

  const [transmitItems, setTransmitItems] = useState({
    Materials: { checked: false },
    Drawings: { checked: false },
    Schedules: { checked: false },
    Commercial: { checked: false },
  });

  const [herewithItems, setHerewithItems] = useState({
    Correspondence: { checked: false },
    Reports: { checked: false },
    Documents: { checked: false }
  });

  const [submittedFor, setSubmittedFor] = useState(
    SUBMITTED_FOR_OPTIONS.reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {})
  );

  const [documentTypes, setDocumentTypes] = useState({
    Original: false,
    Copies: false,
    Contractor: false
  });

  const [formData, setFormData] = useState({
    transmittalId: "",
    projectName: "",
    contractForm: "",
    date: new Date().toISOString().split("T")[0],
    contractor: "",
    engineer: "",
    client: "",
    revisionNo: "",
    from: "",
    to: "",
    status: "",
    contractorText: "",
    subcontractorText: "",
    engineerText: "",
    engineerName: "",
    engineerDate: "",
    clientName: "",
    clientDate: "",
    clientText: "",
    approvedBy: "",
    approvedDate: today,
    transmitItems: {},
    herewithItems: {},
    submittedFor: {},
    documentTypes: {},
    responseDate: ""
  });

  // Initialize documentRows based on whether documents are selected
  useEffect(() => {
    const selectedDocuments = location.state?.selectedDocuments || [];
    if (selectedDocuments.length > 0) {
      // Case: Documents selected from ViewDocumentPage
      setDocumentRows(selectedDocuments.map((doc, index) => ({
        id: index + 1,
        docRef: doc.documentReference || '',
        description: doc.documentDescription || '',
        revision: '',
        specNo: '',
        code: doc.code || ''
      })));
    } else {
      // Case: No documents selected, initialize with one empty row
      setDocumentRows([{
        id: 1,
        docRef: '',
        description: '',
        revision: '',
        specNo: '',
        code: ''
      }]);
    }
  }, [location.state]);

  // Sync formData with transmitItems, herewithItems, etc.
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      transmitItems,
      herewithItems,
      submittedFor,
      documentTypes,
    }));
  }, [transmitItems, herewithItems, submittedFor, documentTypes]);

  const handleRowChange = (id, field, value) => {
    setDocumentRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  const handleDocRefChange = (id, value) => {
    const selectedDoc = documents.find(doc => doc.documentReference === value);
    const description = selectedDoc ? selectedDoc.documentDescription : '';

    setDocumentRows((prev) =>
      prev.map((row) =>
        row.id === id
          ? { ...row, docRef: value, description }
          : row
      )
    );
  };

  const handleProjectChange = (e) => {
    const projectName = e.target.value;
    setSelectedProject(projectName);

    if (!assignedProjects.length) return;

    const project = assignedProjects.find(p => p.projectName === projectName);

    if (project) {
      const client = project.client || project.clientName || "";
      const engineer = project.engineer || "";
      const contractor = project.contractor || "";

      setClientName(client);
      setEngineer(engineer);
      setContractor(contractor);

      setFormData(prev => ({
        ...prev,
        clientName: client,
        engineer: engineer,
        contractor: contractor,
        contractForm: project.contractForm || "",
        projectName: projectName,
      }));
    } else {
      setClientName('');
      setEngineer('');
      setContractor('');
      setFormData(prev => ({
        ...prev,
        clientName: '',
        engineer: '',
        contractor: '',
        contractForm: '',
        projectName: '',
      }));
    }
  };

  const toggleCheckbox = (section, item) => {
    const updaters = {
      transmit: setTransmitItems,
      herewith: setHerewithItems,
      submittedFor: setSubmittedFor,
      documentTypes: setDocumentTypes,
    };

    updaters[section](prev => {
      if (section === "transmit" || section === "herewith") {
        // Always return object with checked property
        return {
          ...prev,
          [item]: { checked: !(prev[item]?.checked || false) }
        };
      } else {
        // For submittedFor and documentTypes, use boolean
        return {
          ...prev,
          [item]: !prev[item]
        };
      }
    });
  };

  // const handleApprove = () => setIsApproved(true);
  const handleApprove = () => {
    setIsApproved(true);

    setFormData(prev => ({
      ...prev,
      approvedDate: prev.approvedDate || new Date().toISOString().split("T")[0]
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      // 🔥 REAL-TIME MIRROR
      if (name === "from") {
        return {
          ...prev,
          from: value,
          approvedBy: value, // 👈 INSTANT SYNC
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });

    if (value.trim()) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const pdfStyles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  row: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  section: {
    marginBottom: 6,
  },
  label: {
    width: 80,
    fontWeight: 'bold',
  },
  valueBox: {
    flex: 1,
    borderWidth: 0.5,
    borderColor: '#000',
    padding: 3,
    minHeight: 14,
    justifyContent: 'center',
  },

  /* 🔴 IMPORTANT PART */
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 20,   // <-- ADD THIS
    marginBottom: 2,
  },
  checkboxBox: {
    width: 14,
    height: 14,
    borderWidth: 1,
    borderColor: '#000',
    marginRight: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableHeader: {
    flexDirection: 'row',
    borderWidth: 0.5,
    borderColor: '#000',
  },
  tableHeadCell: {
    borderRightWidth: 0.5,
    borderColor: '#000',
    padding: 3,
    fontWeight: 'bold',
    fontSize: 9,
  },
  tableRow: {
    flexDirection: 'row',
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: '#000',
  },
  tableCell: {
    padding: 3,
    fontSize: 9,
    borderRightWidth: 0.5,
    borderColor: '#000',
  },
  remarksBox: {
    borderWidth: 0.5,
    borderColor: '#000',
    minHeight: 30,
    padding: 3,
    marginBottom: 6,
  },
  signatureImg: {
    width: 80,
    height: 30,
    marginTop: 4,
  },
  stampImg: {
    width: 80,
    height: 80,
    marginTop: 6,
  },
  centerNote: {
    textAlign: 'center',
    fontSize: 9,
  },
});

  const generatePDF = async (transId, snapshot) => {
    try {
      // 1) Capture signatures from canvas
      const engineerCanvas = document.getElementById("signaturePad2");
      const clientCanvas = document.getElementById("signaturePad3");

      const engineerSign = engineerCanvas?.toDataURL("image/png") || null;
      const clientSign = clientCanvas?.toDataURL("image/png") || null;

      // 2) Build PDF document using SNAPSHOT values
      const pdfDoc = (
        <TransmittalPdfDocument
          transId={transId}
          formData={formData}
          documentRows={documentRows}

          clientName={clientName}
          contractor={contractor}
          engineer={engineer}

          // ⭐ USE SNAPSHOT values (not state)
          transmitItems={snapshot.transmitItems}
          herewithItems={snapshot.herewithItems}
          submittedFor={snapshot.submittedFor}
          documentTypes={snapshot.documentTypes}

          engineerSign={engineerSign}
          clientSign={clientSign}
          stampSrc={approveSeal}
        />
      );

      // 3) Convert to Blob
      const blob = await pdf(pdfDoc).toBlob();
      const filename = `${transId}.pdf`;

      // Download PDF
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);

      // 5) Return file for backend
      return {
        file: new File([blob], filename, { type: "application/pdf" }),
        url,
      };

    } catch (err) {
      console.error("PDF generate error:", err);
      message.error("Failed to generate PDF.");
    }
  };

  const PdfCheckbox = ({ mark }) => (
    <View style={pdfStyles.checkboxBox}>
      <Text style={{ fontSize: 9 }}>{mark}</Text>
    </View>
  );

  const TransmittalPdfDocument = ({
    transId,
    formData,
    clientName,
    contractor,
    engineer,
    transmitItems,
    herewithItems,
    submittedFor,
    documentTypes,
    documentRows,
    engineerSign,
    clientSign,
    stampSrc,
  }) => (
    <Document>
      <Page size="A4" style={[pdfStyles.page, { padding: 24 }]}>

        {/* HEADER */}
        <View style={[pdfStyles.row, { marginBottom: 16 }]}>
          <View style={[pdfStyles.valueBox, { flex: 1 }]}><Text>{clientName}</Text></View>
          <View style={[pdfStyles.valueBox, { flex: 1 }]}><Text>{contractor}</Text></View>
          <View style={[pdfStyles.valueBox, { flex: 1 }]}><Text>{engineer}</Text></View>
          <View style={[pdfStyles.valueBox, { flex: 1, fontWeight: "bold" }]}>
            <Text>Document Transmittal Sheet</Text>
          </View>
        </View>

        {/* PROJECT DETAILS */}
        <View style={[pdfStyles.section, { marginBottom: 12 }]}>
          {[
            ["Project", formData.projectName, "Contract No", formData.contractForm],
            ["Date", formData.date, "Contractor", contractor],
            ["Revision No", formData.revisionNo, "From", formData.from],
            ["To", formData.to, "Transmittal ID", transId],
          ].map(([l1, v1, l2, v2], i) => (
            <View style={[pdfStyles.row, { marginBottom: 4 }]} key={i}>
              <Text style={pdfStyles.label}>{l1}:</Text>
              <View style={pdfStyles.valueBox}><Text>{v1}</Text></View>

              <Text style={[pdfStyles.label, { marginLeft: 10 }]}>{l2}:</Text>
              <View style={pdfStyles.valueBox}><Text>{v2}</Text></View>
            </View>
          ))}
        </View>

        {/* WE TRANSMIT HEREWITH */}
        <View style={[pdfStyles.section, { marginBottom: 12 }]}>
          <Text style={{ fontWeight: "bold", marginBottom: 4 }}>We transmit herewith:</Text>
          <View style={[pdfStyles.row, { justifyContent: "space-between" }]}>

            {/* Left group - transmitItems uses .mark */}
            <View style={{ flex: 1 }}>
              {["Materials", "Drawings", "Schedules", "Commercial"].map((item) => (
                <View style={pdfStyles.checkboxRow} key={item}>
                  <PdfCheckbox mark={transmitItems[item]?.mark || ""} />
                  <Text>{item}</Text>
                </View>
              ))}
            </View>

            {/* Right group - herewithItems uses .mark */}
            <View style={{ flex: 1 }}>
              {["Correspondence", "Reports", "Documents"].map((item) => (
                <View style={pdfStyles.checkboxRow} key={item}>
                  <PdfCheckbox mark={herewithItems[item]?.mark || ""} />
                  <Text>{item}</Text>
                </View>
              ))}
            </View>

            {/* Action codes */}
            <View style={{ flex: 1 }}>
              <Text>A: Approved</Text>
              <Text>B: Approved with Comments</Text>
              <Text>C: Revise & Resubmit</Text>
              <Text>D: Rejected</Text>
            </View>

          </View>
        </View>

        {/* DOCUMENT TABLE */}
        <Text style={{ fontWeight: "bold", marginBottom: 4 }}>Documents:</Text>

        <View style={pdfStyles.tableHeader}>
          <Text style={[pdfStyles.tableHeadCell, { width: "7%" }]}>SL.NO</Text>
          <Text style={[pdfStyles.tableHeadCell, { width: "40%" }]}>Doc.Reference</Text>
          <Text style={[pdfStyles.tableHeadCell, { width: "15%" }]}>Revision</Text>
          <Text style={[pdfStyles.tableHeadCell, { width: "38%" }]}>Description</Text>
        </View>

        {documentRows.map((row, i) => (
          <View style={pdfStyles.tableRow} key={i}>
            <Text style={[pdfStyles.tableCell, { width: "7%", textAlign: "center" }]}>{i + 1}</Text>
            <Text style={[pdfStyles.tableCell, { width: "40%" }]}>{row.docRef}</Text>
            <Text style={[pdfStyles.tableCell, { width: "15%" }]}>{row.revision}</Text>
            <Text style={[pdfStyles.tableCell, { width: "38%" }]}>{row.description}</Text>
          </View>
        ))}

        {/* SUBMITTED FOR - uses plain string value */}
        <Text style={{ fontWeight: "bold", marginTop: 12 }}>Submitted For:</Text>

        {/* <View style={[pdfStyles.row, { marginBottom: 12, justifyContent: "space-between" }]}>
          {["For Approval", "For Your Information", "Response Required"].map((k) => (
          <View style={pdfStyles.checkboxRow} key={k}>
            <PdfCheckbox mark={submittedFor[k] || ""} />
            <Text>{k}</Text>
          </View>
        ))} */}
        <View style={[pdfStyles.row, { marginBottom: 12, flexWrap: "wrap" }]}>
          {SUBMITTED_FOR_OPTIONS.map((k) => (
            <View style={pdfStyles.checkboxRow} key={k}>
              <PdfCheckbox mark={submittedFor[k] || ""} />
              <Text>{k}</Text>
            </View>
          ))}

        </View>

        {isSubcontractorDC && (
          <div className="border p-2">
            <div className="font-semibold mb-1">Subcontractor remarks</div>
            <textarea
              className="w-full border h-12 mb-1 text-xs p-1"
              value={formData.subcontractorText || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  subcontractorText: e.target.value,
                }))
              }
            ></textarea>
          </div>
        )}

        {/* REMARKS */}
        {!hideContractorRemarks && (
          <>
            <Text style={{ fontWeight: "bold" }}>Contractor remarks</Text>
            <View style={pdfStyles.remarksBox}><Text>{formData.contractorText}</Text></View>
          </>
        )}

        {!hideEngineerRemarks && (
        <>
        <Text style={{ fontWeight: "bold" }}>Engineer's remarks</Text>
        <View style={pdfStyles.remarksBox}><Text>{formData.engineerText}</Text></View>

        <View style={[pdfStyles.row, { marginBottom: 8 }]}>
          <Text style={pdfStyles.label}>Engineer Name:</Text>
          <View style={pdfStyles.valueBox}><Text>{formData.engineerName}</Text></View>
          <View style={{ flex: 1 }}>
            <Text>Engineer Signature:</Text>
            {engineerSign && <Image src={engineerSign} style={pdfStyles.signatureImg} />}
          </View>
          <Text style={[pdfStyles.label, { marginLeft: 10 }]}>Engineer Date:</Text>
          <View style={pdfStyles.valueBox}><Text>{formData.engineerDate}</Text></View>
        </View>
        </>
        )}

        {!hideClientRemarks && (
          <>
            <Text style={{ fontWeight: "bold" }}>Client's remarks</Text>
            <View style={pdfStyles.remarksBox}><Text>{formData.clientText}</Text></View>

            <View style={[pdfStyles.row, { marginBottom: 8 }]}>
              <Text style={pdfStyles.label}>Client Name:</Text>
              <View style={pdfStyles.valueBox}><Text>{formData.clientName}</Text></View>
              <View style={{ flex: 1 }}>
                <Text>Client Signature:</Text>
                {clientSign && <Image src={clientSign} style={pdfStyles.signatureImg} />}
              </View>
              <Text style={[pdfStyles.label, { marginLeft: 10 }]}>Client Date:</Text>
              <View style={pdfStyles.valueBox}><Text>{formData.clientDate}</Text></View>
            </View>
          </>
        )}

        <Text style={[pdfStyles.centerNote, { marginTop: 14 }]}>
          No comments or signature on this form relieve the contractor from any obligations under the contract
        </Text>

        {/* DOC TYPES & APPROVAL - uses plain string value */}
        <View style={[pdfStyles.row, { marginTop: 12 }]}>
          <View style={{ flex: 1 }}>
            {["Original", "Copies", "Contractor"].map((k) => (
            <View style={pdfStyles.checkboxRow} key={k}>
              <PdfCheckbox mark={documentTypes[k] || ""} />
              <Text>{k}</Text>
            </View>
          ))}

          </View>

          <View style={{ flex: 1 }}>
            <Text>Approved By:</Text>
            <View style={pdfStyles.valueBox}><Text>{formData.approvedBy}</Text></View>

            <Text style={{ marginTop: 4 }}>Date:</Text>
            <View style={pdfStyles.valueBox}><Text>{formData.approvedDate}</Text></View>

            {stampSrc && (
              <Image
                src={stampSrc}
                style={{ width: 80, height: 80, marginTop: 10 }}
              />
            )}
          </View>
        </View>

      </Page>
    </Document>
  );

  const handleSend = async () => {
    try {
      setLoading(true);

      const finalData = {
        ...formData,
        projectName: selectedProject,
        client: clientName,
        engineer: engineer,
        contractor,
        date: formData.date || new Date().toISOString().split("T")[0],
        responseDate: formData.responseDate,
        documents: documentRows.map(row => ({
          docRef: row.docRef,
          revision: row.revision,
          specNo: row.specNo,
          description: row.description,
        })),
      };

      const saveRes = await axios.post("transmittal-form", finalData);
      const backendTransId = saveRes.data.transmittalId;

      // Create snapshot with proper structure
      const snapshot = {
        transmitItems: Object.fromEntries(
          Object.entries(transmitItems).map(([key, val]) => {
            const isChecked = val?.checked || false;
            return [
              key,
              { checked: isChecked, mark: isChecked ? "•" : "" }
            ];
          })
        ),

        herewithItems: Object.fromEntries(
          Object.entries(herewithItems).map(([key, val]) => {
            const isChecked = val?.checked || false;
            return [
              key,
              { checked: isChecked, mark: isChecked ? "•" : "" }
            ];
          })
        ),

        submittedFor: Object.fromEntries(
          Object.entries(submittedFor).map(([key, val]) => [
            key,
            val ? "•" : ""
          ])
        ),

        documentTypes: Object.fromEntries(
          Object.entries(documentTypes).map(([key, val]) => [
            key,
            val ? "•" : ""
          ])
        ),
      };

      setFormData(prev => ({ ...prev, transmittalId: backendTransId }));

      const { file, url } = await generatePDF(backendTransId, snapshot);
      const transFile = { file, url, name: file.name };

      setTransmittalFile(transFile);

      // 3️⃣ Navigate
      navigate('/home/view-document', {
        state: {
          selectedDocuments: documentRows.map(row => ({
            documentReference: row.docRef,
            documentDescription: row.description,
            code: row.code
          })),
          transmittalFile: transFile,
          openSendModal: true
        },
      });

      message.success("Saved and ready to send.");
    } catch (err) {
      console.error(err);
      message.error("Failed to send");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalData = {
      ...formData,
      projectName: selectedProject,
      client: clientName,
      engineer: engineer,
      contractor,
      date: formData.date || new Date().toISOString().split("T")[0],
      responseDate: formData.responseDate,
      documents: documentRows.map(row => ({
        docRef: row.docRef,
        revision: row.revision,
        specNo: row.specNo,
        description: row.description,
      })),
    };

    try {
      setLoading(true);
      const response = await axios.post("transmittal-form", finalData);
      if (response.status === 200 || response.status === 201) {
        message.success("Form submitted successfully!");
        const { file, url } = await generatePDF();
        setTransmittalFile({ file, url, name: file.name });
      }
    } catch (error) {
      message.error("Failed to submit form");
    } finally {
      setLoading(false);
    }
  };

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const res = await axios.post('get-all-documents', { role, user, projectName });
      if (res && res.data && res.data.documents) {
        setDocuments(res.data.documents);
        const reformattedArray = res.data.documents.map(({ projectName }) => ({ 'text': projectName, 'value': projectName }));
        const unique = [];
        reformattedArray.map(x => unique.filter(a => a.text === x.text && a.value === x.value).length > 0 ? null : unique.push(x));
        setFilters(unique);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong');
      }
    }
  };

  useEffect(() => {
    if (projectName) {
      fetchDocuments();
    }
  }, [projectName]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get("/get-projects", { params: { user } });
        const projects = response.data.projects;

        const filteredProjects = projectName
          ? projects.filter(p => p.projectName === projectName)
          : projects;

        setAssignedProjects(filteredProjects);

        if (projectName && filteredProjects.length > 0) {
          const p = filteredProjects[0];
          setSelectedProject(p.projectName);
          const client = p.client || p.clientName || "";
          const eng = p.engineer || "";
          const cont = p.contractor || "";

          setClientName(client);
          setEngineer(eng);
          setContractor(cont);

          setFormData(prev => ({
            ...prev,
            clientName: client,
            engineer: eng,
            contractor: cont,
            contractForm: p.contractForm || "",
            projectName: p.projectName,
          }));
        } else if (filteredProjects.length === 1) {
          const p = filteredProjects[0];
          setSelectedProject(p.projectName);
          const client = p.client || p.clientName || "";
          const eng = p.engineer || "";
          const cont = p.contractor || "";

          setClientName(client);
          setEngineer(eng);
          setContractor(cont);

          setFormData(prev => ({
            ...prev,
            clientName: client,
            engineer: eng,
            contractor: cont,
            contractForm: p.contractForm || "",
            projectName: p.projectName,
          }));
        }
      } catch (error) {
        console.error("Error fetching assigned projects:", error);
      }
    };

    fetchProjects();
  }, [user, projectName]);

  const handlePrint = () => {
    const originalContent = document.body.innerHTML;
    const printContent = formRef.current.cloneNode(true);

    const checkboxes = formRef.current.querySelectorAll("input[type='checkbox']");
    const clonedCheckboxes = printContent.querySelectorAll("input[type='checkbox']");

    checkboxes.forEach((checkbox, index) => {
      if (checkbox.checked) {
        clonedCheckboxes[index].setAttribute("checked", "checked");
      }
    });

    const style = `
      <style>
        @media print {
          @page {
            size: A4;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .print-content {
            width: 100%;
            max-height: 100vh;
            overflow: hidden;
            page-break-inside: avoid;
            transform: scale(0.95);
            transform-origin: top;
            padding-top: 15mm;
          }
          button, .no-print {
            display: none !important;
          }
        }
      </style>
    `;

    const printWrapper = document.createElement("div");
    printWrapper.className = "print-content";
    printWrapper.appendChild(printContent);

    document.body.innerHTML = style + printWrapper.outerHTML;

    window.print();

    setTimeout(() => {
      document.body.innerHTML = originalContent;
      window.location.reload();
    }, 100);
  };

  return (
    <>
      <div id="pdf-print-container" style={{ display: "none" }}></div>
      <div ref={wrapperRef} className="transmittal-wrapper relative flex-1 bg-white p-10 overflow-y-auto ml-10 mr-2 min-h-screen">
        <div id="a4-print-area">
        <form ref={formRef}>
          {/* Header Section */}
          <div className="flex justify-between items-center mb-2 gap-2">
            <div className="flex gap-2 flex-1">
              <div className="w-1/5 h-16 flex items-center justify-center p-1 border rounded text-sm">{clientName}</div>
              <div className="w-1/5 h-16 flex items-center justify-center p-1 border rounded text-sm">{contractor}</div>
              <div className="w-1/5 h-16 flex items-center justify-center p-1 border rounded text-sm">{engineer}</div>
              <div className="w-2/5 h-16 flex items-center justify-center p-1 border rounded font-bold text-lg">Document Transmittal Sheet</div>
            </div>
          </div>

          {/* Project Details */}
          <div className="grid grid-cols-2 gap-2 text-xs mb-2">
            <div className="flex items-center">
              <label className="w-20 font-semibold">Project:</label>
              {assignedProjects.length === 1 ? (
                <input
                  type="text"
                  className="flex-1 border p-1 h-6"
                  name="project"
                  value={selectedProject}
                  disabled
                />
              ) : (
                <select
                  className="flex-1 border p-1 h-6"
                  name="project"
                  value={selectedProject}
                  onChange={handleProjectChange}
                >
                  <option value="">Select Project</option>
                  {assignedProjects.map((proj) => (
                    <option key={proj.projectName} value={proj.projectName}>
                      {proj.projectName}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className="flex items-center">
              <label className="w-20 font-semibold">Contract No:</label>
              <input
                type="text"
                className="flex-1 border p-1 h-6"
                name="contractForm"
                value={formData.contractForm}
                onChange={handleInputChange}
                disabled
              />
            </div>
            <div className="flex items-center">
              <label className="w-20 font-semibold">Date:</label>
              <input
                type="date"
                className="flex-1 border p-1 h-6"
                value={formData.date || new Date().toISOString().split("T")[0]}
                onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))}
                disabled
              />
            </div>
            <div className="flex items-center">
              <label className="w-20 font-semibold">Contractor:</label>
              <input
                type="text"
                className="flex-1 border p-1 h-6"
                name="contractor"
                value={contractor}
                onChange={handleInputChange}
                disabled
              />
            </div>
            <div className="flex items-center">
              <label className="w-20 font-semibold">Revision No:</label>
              <input
                type="text"
                className="flex-1 border p-1 h-6"
                name="revisionNo"
                value={formData.revisionNo}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex items-center">
              <label className="w-20 font-semibold">From:</label>
              <input
                type="text"
                className="flex-1 border p-1 h-6"
                name="from"
                value={formData.from}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex items-center">
              <label className="w-20 font-semibold">To:</label>
              <input
                type="text"
                className="flex-1 border p-1 h-6"
                name="to"
                value={formData.to}
                onChange={handleInputChange}
              />
            </div>
            {/* ✅ Always show Transmittal ID field */}
            <div className="flex items-center">
              <label className="w-20 font-semibold">Transmittal ID:</label>
              <span className="flex-1 border p-1 h-6 bg-gray-200">
                {formData.transmittalId || "Generating..."}
              </span>
            </div>
          </div>

          {/* Document Type Section */}
          <div className="border p-4 mb-2 text-xs">
            <div className="flex gap-4">
              <div className="w-2/4">
                <p><strong>We transmit herewith:</strong></p>
                <div className="border p-2 flex justify-between">
                  <div className="w-1/2 pr-2">
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={transmitItems?.Materials?.checked || false}
                        onChange={() => toggleCheckbox("transmit", "Materials")}
                      />
                      <span>Materials</span>
                    </div>
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={transmitItems?.Drawings?.checked || false}
                        onChange={() => toggleCheckbox("transmit", "Drawings")}
                      />
                      <span>Drawings</span>
                    </div>
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={transmitItems?.Schedules?.checked || false}
                        onChange={() => toggleCheckbox("transmit", "Schedules")}
                      />
                      <span>Schedules</span>
                    </div>
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={transmitItems?.Commercial?.checked || false}
                        onChange={() => toggleCheckbox("transmit", "Commercial")}
                      />
                      <span>Commercial</span>
                    </div>
                  </div>
                  <div className="w-1/2 pl-2">
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={herewithItems?.Correspondence?.checked || false}
                        onChange={() => toggleCheckbox("herewith", "Correspondence")}
                      />
                      <span>Correspondence</span>
                    </div>
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={herewithItems?.Reports?.checked || false}
                        onChange={() => toggleCheckbox("herewith", "Reports")}
                      />
                      <span>Reports</span>
                    </div>
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        className="mr-1"
                        checked={herewithItems?.Documents?.checked || false}
                        onChange={() => toggleCheckbox("herewith", "Documents")}
                      />
                      <span>Documents</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-1/4">
                <div className="font-semibold mb-1">The following items:</div>
                <div className="border p-1 text-xs">
                  <div className="font-semibold text-gray-500">Action Codes:</div>
                  <div>A: Approved</div>
                  <div>B: Approved with Comments</div>
                  <div>C: Revise & Resubmit</div>
                  <div>D: Rejected</div>
                </div>
              </div>
            </div>
          </div>

          {/* Document Table */}
          <table className="w-full border text-xs mb-2 table-fixed">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-1 w-[5%]">SL.NO</th>
                <th className="border p-1 w-[40%]">Doc.Reference</th>
                <th className="border p-1 w-[10%]">Revision</th>
                <th className="border p-1 w-[45%]">Description</th>
              </tr>
            </thead>
            <tbody>
              {documentRows.length > 0 ? (
                documentRows.map((row) => (
                  <tr key={row.id}>
                    <td className="border p-1 text-center w-[5%]">{row.id}</td>
                    <td className="border p-1 w-[40%]">
                      <Select
                        className="w-full h-5 text-xs"
                        value={row.docRef || undefined}
                        onChange={(value) => handleDocRefChange(row.id, value)}
                        placeholder="Select Document Reference"
                        loading={loading}
                      >
                        {documents.map((doc) => (
                          <Option key={doc.documentReference} value={doc.documentReference}>
                            {doc.documentReference}
                          </Option>
                        ))}
                      </Select>
                    </td>
                    {["revision"
                    // , "specNo"
                    ].map((field) => (
                      <td className="border p-1 w-[10%]" key={field}>
                        <input
                          type="text"
                          className="w-full h-5 text-xs"
                          value={row[field] || ""}
                          onChange={(e) => handleRowChange(row.id, field, e.target.value)}
                        />
                      </td>
                    ))}
                    <td className="border p-1 w-[45%]">
                      <input
                        type="text"
                        className="w-full h-5 text-xs"
                        value={row.description || ""}
                        onChange={(e) => handleRowChange(row.id, "description", e.target.value)}
                        disabled
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="border p-1 text-center">
                    No documents selected
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Submission Status */}
          {/* <div className="text-xs mb-2">
            <div className="font-semibold mb-1">Submitted For:</div>
            <div className="grid grid-cols-4 gap-1">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-1"
                  checked={submittedFor?.["For Approval"] || false}
                  onChange={() => toggleCheckbox("submittedFor", "For Approval")}
                />
                <span>For Approval</span>
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-1"
                  checked={submittedFor?.["For Your Information"] || false}
                  onChange={() => toggleCheckbox("submittedFor", "For Your Information")}
                />
                <span>For Your Information</span>
              </label>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-1"
                  checked={submittedFor?.["Response Required"] || false}
                  onChange={() => toggleCheckbox("submittedFor", "Response Required")}
                />
                <span>Response Required</span>
              </label>
              {submittedFor?.["Response Required"] && (
                <div className="flex items-center">
                  <label className="mr-2 font-semibold">Response Date:</label>
                  <DatePicker
                    className="w-32 h-6 text-xs"
                    value={formData.responseDate ? moment(formData.responseDate) : null}
                    onChange={(date, dateString) =>
                      setFormData((prev) => ({ ...prev, responseDate: dateString }))
                    }
                    format="YYYY-MM-DD"
                  />
                </div>
              )}
            </div>
          </div> */}

          <div className="text-xs mb-2">
            <div className="font-semibold mb-1">Submitted For:</div>

            <div className="grid grid-cols-4 gap-1">
              {SUBMITTED_FOR_OPTIONS.map((option) => (
                <label key={option} className="flex items-center">
                  <input
                    type="checkbox"
                    className="mr-1"
                    checked={submittedFor?.[option] || false}
                    onChange={() => toggleCheckbox("submittedFor", option)}
                  />
                  <span>{option}</span>
                </label>
              ))}

              {/* Response Date only when Response Required */}
              {submittedFor?.["Response Required"] && (
                <div className="flex items-center col-span-2">
                  <label className="mr-2 font-semibold">Response Date:</label>
                  <DatePicker
                    className="w-32 h-6 text-xs"
                    value={formData.responseDate ? moment(formData.responseDate) : null}
                    onChange={(date, dateString) =>
                      setFormData((prev) => ({ ...prev, responseDate: dateString }))
                    }
                    format="YYYY-MM-DD"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Signature Sections */}
          <div className="space-y-2 text-xs">
            {isSubcontractorDC && (
              <div className="border p-2">
                <div className="font-semibold mb-1">Subcontractor remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.subcontractorText || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      subcontractorText: e.target.value,
                    }))
                  }
                ></textarea>
              </div>
            )}
            {!hideContractorRemarks && (
              <div className="border p-2">
                <div className="font-semibold mb-1">Contractor remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.contractorText}
                  onChange={(e) => setFormData((prev) => ({ ...prev, contractorText: e.target.value }))}
                ></textarea>
              </div>
            )}

            {/* Engineer Section */}
            {!hideEngineerRemarks && (
              <div className="border p-2">
                <div className="font-semibold mb-1">Engineer's remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.engineerText}
                  onChange={(e) => setFormData((prev) => ({ ...prev, engineerText: e.target.value }))}
                ></textarea>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className="block">Engineer Name:</label>
                    <input
                      type="text"
                      className="border w-full h-6"
                      value={formData.engineerName}
                      onChange={(e) => setFormData((prev) => ({ ...prev, engineerName: e.target.value }))}
                    />
                  </div>
                  <div>
                    <label className="block">Engineer Signature:</label>
                    <canvas id="signaturePad2" className="border rounded w-full h-6 bg-white"></canvas>
                  </div>
                  <div>
                    <label className="block">Engineer Date:</label>
                    <input
                      type="date"
                      className="border w-full h-6"
                      value={formData.engineerDate ? formData.engineerDate.split("T")[0] : ""}
                      onChange={(e) => setFormData((prev) => ({ ...prev, engineerDate: e.target.value }))}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Client Section */}
            {!hideClientRemarks && (
              <div className="border p-2">
                <div className="font-semibold mb-1">Client's remarks</div>
                <textarea
                  className="w-full border h-12 mb-1 text-xs p-1"
                  value={formData.clientText}
                  onChange={(e) => setFormData((prev) => ({ ...prev, clientText: e.target.value }))}
                ></textarea>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className="block">Client Name:</label>
                    <input
                      type="text"
                      className="border w-full h-6"
                      value={formData.clientName}
                      onChange={(e) => setFormData((prev) => ({ ...prev, clientName: e.target.value }))}
                    />
                  </div>
                  <div>
                    <label className="block">Client Signature:</label>
                    <canvas id="signaturePad3" className="border rounded w-full h-6 bg-white"></canvas>
                  </div>
                  <div>
                    <label className="block">Client Date:</label>
                    <input
                      type="date"
                      className="border w-full h-6"
                      value={formData.clientDate ? formData.clientDate.split("T")[0] : ""}
                      onChange={(e) => setFormData((prev) => ({ ...prev, clientDate: e.target.value }))}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Restriction */}
            <div className="border p-2 text-center">
              <h5 className="text-sm font-semibold">
                No comments or signature on this form relieve the contractor from any obligations under the contract
              </h5>
            </div>

            <div className="border p-2 mt-4 flex">
              <div className="w-2/5 flex flex-col space-y-2">
                <label className="flex items-center text-xs">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={documentTypes?.Original || false}
                    onChange={() => toggleCheckbox("documentTypes", "Original")}
                  />
                  Original
                </label>
                <label className="flex items-center text-xs">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={documentTypes?.Copies || false}
                    onChange={() => toggleCheckbox("documentTypes", "Copies")}
                  />
                  Copies
                </label>
                <label className="flex items-center text-xs">
                  <input
                    type="checkbox"
                    className="mr-2"
                    checked={documentTypes?.Contractor || false}
                    onChange={() => toggleCheckbox("documentTypes", "Contractor")}
                  />
                  Contractor
                </label>
              </div>
              <div className="w-3/5 flex items-center" style={{ marginLeft: '10.5rem' }}>
                {role.includes('Document Controller') && !isApproved && (
                  <button onClick={handleApprove} className="bg-blue-500 text-white px-4 py-2">
                    Approve
                  </button>
                )}
                {(isApproved || role.includes('Super User')) && (
                  <div className="flex items-center space-x-3">
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold">Approved By:</label>
                      <input
                        type="text"
                        className="border w-44 h-10 p-2 text-sm"
                        value={formData.approvedBy}
                        onChange={(e) =>
                          setFormData((prev) => ({ ...prev, approvedBy: e.target.value }))
                        }
                        disabled={!role.includes('Document Controller')}
                      />
                      <label className="text-xs font-semibold mt-1">Date:</label>
                      <input
                        type="date"
                        className="border w-44 h-10 p-2 text-sm"
                        value={formData.approvedDate ? formData.approvedDate.split("T")[0] : ""}
                        onChange={(e) =>
                          setFormData((prev) => ({ ...prev, approvedDate: e.target.value }))
                        }
                        disabled={!role.includes('Document Controller')}
                      />
                    </div>
                    <img src={approveSeal} alt="Approved Seal" className="w-32 h-32 opacity-90" />
                  </div>
                )}
              </div>
            </div>
          </div>

        </form>
        </div>
          {((role.includes('Super User')) || (role.includes('Document Controller') && isApproved)) && (
            <div className="flex justify-center gap-4 mt-2">
              <Button onClick={handlePrint} className="bg-blue-500 text-white px-3 py-1 text-sm rounded">
                Print Form
              </Button>
              {/* <Popconfirm
                title="Are you sure you want to save this transmittal form?"
                onConfirm={handleSubmit}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="button"
                  className="bg-green-500 text-white px-3 py-1 text-sm rounded"
                  loading={loading}
                >
                  Save
                </Button>
              </Popconfirm> */}
              <Button
                type="button"
                className="bg-green-500 text-white px-3 py-1 text-sm rounded"
                onClick={handleSend}
                loading={loading}
                // disabled={!location?.state?.selectedDocuments}
              >
                Send
              </Button>
            </div>
          )}
      </div>
    </>
  );
};

export default Transmittal;